/*
 * 数据上报账号配置 210708
 */
const platFormData = [
  'ks',
  'ks61',
  'ks63',
  'tt',
  'tt77',
  'tt25',
  'dy',
  'dy27',
  'dy05',
  'tx91',
  'tx89',
  'tx90',
  'tx39',
  'tx93',
  'tx97',
  'tx94',
  'dt49',
  'dt63',
  'dt64',
  'dt65',
  'dt66',
  'dk10',
  'dk09',
  'dk08',
  'dk07',
  'dk02',
  'dk01',
  'dk00',
  'dk98',
  'dk99',
  'dk68',
  'dk43',
  'dk45',
  'dk54',
  'dk82',
  'dk39',
  'dk64',
  'dk19',
  'dk66',
  'dk20',
  'dk56',
  'dk801',
  'dk804',
  'dk805',
  'dk806',
  'dk821',
  'dk966',
  'dk977',
  'dk978',
  'dk980',
  'dk981',
  'dk280',
  'dk319',
  'dk334',
  'dk346',
  'dk354',
  'dk231',
  'dk250',
  'dk256',
  'dk365',
  'dk374',
  'dk480',
  'dk945',
  'dk947',
  'dk656',
  'dk698',
  'dk396',
  'dk398',
  'dk400',
  'dr38',
  'dr16',
  'dr92',
  'dr99',
  'dr34',
  'dr13',
  'dr10',
  'dr51',
  'dr50',
  'dr58',
  'dr17',
  'dr70',
  'dr11',
  'dr49',
  'dr46',
  'dr59',
  'dr65',
  'dr26',
  'dr94',
  'dr32',
  'dr31',
  'dr725',
  'dr032',
  'dr079',
  'dr407',
  'dr040',
  'dr455',
  'dr654',
  'dr495',
  'dr358',
  'dr055',
  'dr190',
  'dr989',
  'hm94',
  'hm70',
  'hm71',
  'hm72',
  'hm75',
  'hm53',
  'hm45',
  'hm41',
  'hk23',
  'hk86',
  'hk73',
  'hk58',
  'hk78',
  'hk79',
  'ht22',
  'ht07',
  'ht78',
  'ht02',
  'ht91',
  'ht76',
  'ht26',
  'ht56',
  'ht89',
  'kt24',
  'kt23',
  'kt79',
  'kt01',
  'kt00',
  'kk33',
  'kk34',
  'kk35',
  'kk36',
  'kk37',
  'kk93',
  'kk94',
  'kk95',
  'kd85',
  'kd15',
  'kd40',
  'kd75',
  'kd28',
  'kd72',
  'kd08',
  'kd34',
  'kd36',
  'kd67',
  'kd03',
  'kd23',
  'kd51',
  'kd60',
  'kd88',
  'md49',
  'md54',
  'md09',
  'md05',
  'md44',
  'md69',
  'md23',
  'md96',
  'md35',
  'md84',
  'md42',
  'md70',
  'md71',
  'md87',
  'md04',
  'md85',
  'md77',
  'md28',
  'md72',
  'md214',
  'md454',
  'md935',
  'md847',
  'mt98',
  'mt97',
  'mt99',
  'mt00',
  'mt01',
  'mt03',
  'mt05',
  'mk74',
  'mk47',
  'mk49',
  'mk50',
  'mk53',
  'mk54',
  'mk59',
  'mk65',
  'zt59',
  'zt60',
  'zt61',
  'zt64',
  'gd01',
  'gd02',
  'gd03',
  'gd04',
  'gd05',
  'xt09',
  'xt63',
  'xt64',
  'xt65',
  'xt66',
  'xt68',
  'xt71',
  'xt72',
  'xt75',
  'xt78',
  'xk65',
  'xk78',
  'xk85',
  'xk87',
  'xk89',
  'xk95',
  'xk99',
  'xk05',
  'xk11',
  'xk14',
];
const dataType = {
  'tt': {'sid': '1700985758476296', 'convert_id': 1702804280966219, 'ad_channel': 3}, // 亿码 头条
  'tt77': {'sid': '1700790849931277', 'convert_id': 1704606851418126, 'ad_channel': 3},
  'tt25': {'sid': '1704611256040525', 'convert_id': 1705044574094339, 'ad_channel': 3}, // 亿码 头条 2021-7-12
  'dy': {'sid': '1700985757960199', 'convert_id': 1702806319435851, 'ad_channel': 3},
  'dy27': {'sid': '1700985757035527', 'convert_id': 1704606522890254, 'ad_channel': 3},
  'dy05': {'sid': '1704611256558605', 'convert_id': 1705044374759432, 'ad_channel': 3}, // 亿码 抖音 2021-7-12
  'ks': {'sid': '283685', 'convert_id': 283685, 'ad_channel': 4},
  'ks61': {'sid': '292248', 'convert_id': 292248, 'ad_channel': 4},
  'ks63': {'sid': '293283', 'convert_id': 293283, 'ad_channel': 4},
  'tx91': {'sid': '17005691', 'set_id': '1111885709', 'ad_channel': 1}, // 亿码广点通
  'tx89': {'sid': '17005689', 'set_id': '1111886499', 'ad_channel': 1},
  'tx39': {'sid': '17005039', 'set_id': '1111878094', 'ad_channel': 1},
  'tx90': {'sid': '17005090', 'set_id': '1112027648', 'ad_channel': 1}, // 20205690
  'tx93': {'sid': '21039193', 'set_id': '1111963233', 'ad_channel': 1}, // 亿码广点通 2021-7-12
  'tx97': {'sid': '21039197', 'set_id': '1111963237', 'ad_channel': 1}, // 亿码广点通 2021-7-12
  'tx94': {'sid': '21039194', 'set_id': '1111963239', 'ad_channel': 1}, // 亿码广点通 2021-7-12
  'dt49': {'sid': '20955349', 'set_id': '1112026642', 'ad_channel': 1}, // 东润司机端
  'dt63': {'sid': '20962463', 'set_id': '1111950195', 'ad_channel': 1, 'action': true}, // 东润广点通 2021-8-2 目前为投放，添加转化归因
  'dt64': {'sid': '20962464', 'set_id': '1111950193', 'ad_channel': 1, 'action': true}, // 东润广点通 2021-8-2 目前为投放，添加转化归因
  'dt65': {'sid': '20962465', 'set_id': '1111950189', 'ad_channel': 1, 'action': true}, // 东润广点通 2021-8-2 目前为投放，添加转化归因
  'dt66': {'sid': '20962466', 'set_id': '1112026498', 'ad_channel': 1, 'action': true}, // 东润广点通 2021-8-2 目前为投放，添加转化归因
  'dk10': {'sid': '10418310', 'convert_id': 293554, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-8 2021-8-2 更改转化归因
  'dk09': {'sid': '10418309', 'convert_id': 293556, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk08': {'sid': '10418308', 'convert_id': 293557, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk07': {'sid': '10418307', 'convert_id': 293559, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk02': {'sid': '10418302', 'convert_id': 293561, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk01': {'sid': '10418301', 'convert_id': 293562, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk00': {'sid': '10418300', 'convert_id': 293565, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk99': {'sid': '10418299', 'convert_id': 293566, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk98': {'sid': '10418298', 'convert_id': 293567, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk68': {'sid': '10418268', 'convert_id': 293573, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk43': {'sid': '10426343', 'convert_id': 294559, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-9 更改转化归因
  'dk45': {'sid': '10424945', 'convert_id': 294562, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk54': {'sid': '10424854', 'convert_id': 294564, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk82': {'sid': '10424782', 'convert_id': 294566, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk39': {'sid': '10424739', 'convert_id': 294575, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk64': {'sid': '10424664', 'convert_id': 294577, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk19': {'sid': '10424519', 'convert_id': 294578, 'ad_channel': 4, 'action': true}, // 2021-8-2 更改转化归因
  'dk66': {'sid': '10424466', 'convert_id': 294579, 'ad_channel': 4},
  'dk20': {'sid': '10422620', 'convert_id': 294583, 'ad_channel': 4},
  'dk56': {'sid': '10422556', 'convert_id': 294585, 'ad_channel': 4},
  'dk801': {'sid': '10482801', 'convert_id': 302615, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk804': {'sid': '10482804', 'convert_id': 302621, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk805': {'sid': '10482805', 'convert_id': 302614, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk806': {'sid': '10482806', 'convert_id': 302613, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk821': {'sid': '10482821', 'convert_id': 302612, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk966': {'sid': '10482966', 'convert_id': 302608, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk977': {'sid': '10482977', 'convert_id': 302606, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk978': {'sid': '10482978', 'convert_id': 302605, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk980': {'sid': '10482980', 'convert_id': 302603, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk981': {'sid': '10482981', 'convert_id': 302601, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk280': {'sid': '10497280', 'convert_id': 302638, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk319': {'sid': '10497319', 'convert_id': 302633, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk334': {'sid': '10497334', 'convert_id': 302627, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk346': {'sid': '10497346', 'convert_id': 302626, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk354': {'sid': '10497354', 'convert_id': 302624, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk231': {'sid': '10497231', 'convert_id': 302649, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk250': {'sid': '10497250', 'convert_id': 302646, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk256': {'sid': '10497256', 'convert_id': 302643, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk365': {'sid': '10497365', 'convert_id': 302623, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk374': {'sid': '10497374', 'convert_id': 302622, 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-26 2021-8-3更改转化归因
  'dk480': {'sid': '10417480', 'ad_channel': 4, 'action': true}, // 东润快手 2021-7-27 测试API转化
  'dk945': {'sid': '10434945', 'ad_channel': 4, 'action': true}, // 东润快手 2021-9-13 测试API转化 （司机端）
  'dk947': {'sid': '10434947', 'ad_channel': 4, 'action': true}, // 东润快手 2021-9-13 测试API转化 （司机端）
  'dk656': {'sid': '10840656', 'ad_channel': 4, 'action': true}, // 东润快手 2021-9-23 新增账户
  'dk698': {'sid': '10840698', 'ad_channel': 4, 'action': true}, // 东润快手 2021-9-23 新增账户
  'dk396': {'sid': '10841396', 'ad_channel': 4, 'action': true}, // 东润快手 2021-9-23 新增账户
  'dk398': {'sid': '10841398', 'ad_channel': 4, 'action': true}, // 东润快手 2021-9-23 新增账户
  'dk400': {'sid': '10841400', 'ad_channel': 4, 'action': true}, // 东润快手 2021-9-23 新增账户
  'dr38': {'sid': '1704521568333838', 'convert_id': 1704688667705347, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-8-6 改为API方式
  'dr16': {'sid': '1704620608953416', 'convert_id': 1704688893355016, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-8-6 改为API方式
  // 'dr92': {'sid': '1704680121053192', 'convert_id': 1704688962595851, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-9-30 作废
  'dr99': {'sid': '1704680121505799', 'convert_id': 1704689014814723, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-8-6 改为API方式
  'dr34': {'sid': '1704680121989134', 'convert_id': 1704689063504900, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-8-6 改为API方式
  'dr13': {'sid': '1704680122419213', 'convert_id': 1704692091305987, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-8-6 改为API方式
  'dr10': {'sid': '1704680122858510', 'convert_id': 1704692148488270, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-8-6 改为API方式
  'dr51': {'sid': '1704680123372551', 'convert_id': 1704691817488388, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-8-6 改为API方式
  'dr50': {'sid': '1704680124199950', 'convert_id': 1704692531207181, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-8-6 改为API方式
  'dr58': {'sid': '1704680124626958', 'convert_id': 1704692586685448, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-8 2021-8-6 改为API方式
  'dr17': {'sid': '1705150520367117', 'convert_id': 1706408144037891, 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-7-27 API转化测试
  'dr70': {'sid': '1706418990381070', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-3 API转化新加账户
  'dr11': {'sid': '1706418990818311', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-3 API转化新加账户
  'dr49': {'sid': '1706418991399949', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-3 API转化新加账户
  'dr46': {'sid': '1706418992038046', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-3 API转化新加账户
  'dr59': {'sid': '1706418992509959', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-4 API转化新加账户
  'dr65': {'sid': '1706418992923655', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-4 API转化新加账户
  'dr26': {'sid': '1706418993600526', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-4 API转化新加账户
  'dr94': {'sid': '1706418994129934', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-4 API转化新加账户
  'dr32': {'sid': '1706418994729032', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-25 API转化新加账户
  'dr31': {'sid': '1709496468583431', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-8-30 API转化新加账户
  'dr725': {'sid': '1709496469235725', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-13 API转化新加账户
  'dr032': {'sid': '1709496470273032', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-13 API转化新加账户
  'dr079': {'sid': '1709496469763079', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-13 API转化新加账户
  'dr407': {'sid': '1709496471950407', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-13 API转化新加账户
  'dr040': {'sid': '1709496472492040', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-13 API转化新加账户
  'dr455': {'sid': '1709496473064455', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-13 API转化新加账户
  'dr654': {'sid': '1709496473584654', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-13 API转化新加账户
  'dr495': {'sid': '1711140280511495', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-27 新增账户
  'dr358': {'sid': '1711140281017358', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-27 新增账户
  'dr055': {'sid': '1711140281514055', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-27 新增账户
  'dr190': {'sid': '1711140282034190', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-27 新增账户
  'dr989': {'sid': '1711140282494989', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-27 新增账户
  'dr92': {'sid': '1711140283792392', 'ad_channel': 3, 'action': true}, // 东润头条，抖音 2021-9-30 新增账户 替换 1711140283792392
  'hm94': {'sid': '20927494', 'set_id': '1112028246', 'ad_channel': 1, 'action': true}, // 辉煌腾讯 2021-7-8 2021-8-2 目前未投放，添加转化归因
  'hm70': {'sid': '20983370', 'set_id': '1112028298', 'ad_channel': 1, 'action': true}, // 辉煌腾讯 2021-7-8 2021-8-2 目前未投放，添加转化归因
  'hm71': {'sid': '20983371', 'set_id': '1112028318', 'ad_channel': 1, 'action': true}, // 辉煌腾讯 2021-7-8 2021-8-2 目前未投放，添加转化归因
  'hm72': {'sid': '20983372', 'set_id': '1111951989', 'ad_channel': 1}, // 辉煌司机端
  'hm75': {'sid': '20983375', 'set_id': '1111952053', 'ad_channel': 1, 'action': true}, // 辉煌腾讯 2021-7-8 2021-8-2 目前未投放，添加转化归因
  'hm53': {'sid': '21034053', 'set_id': '1112037878', 'ad_channel': 1, 'action': true}, // 辉煌2021-7-10 2021-8-2 目前未投放，添加转化归因
  'hm45': {'sid': '21034045', 'set_id': '1200002440', 'ad_channel': 1, 'action': true}, // 辉煌2021-7-10 2021-8-2 目前未投放，添加转化归因
  'hm41': {'sid': '21034041', 'set_id': '1111961063', 'ad_channel': 1, 'action': true}, // 辉煌2021-7-10 2021-8-2 目前未投放，添加转化归因
  'hk23': {'sid': '10421123', 'convert_id': 293687, 'ad_channel': 4, 'action': true}, // 辉煌快手 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'hk86': {'sid': '10421086', 'convert_id': 293696, 'ad_channel': 4, 'action': true}, // 辉煌快手 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'hk73': {'sid': '10421073', 'convert_id': 293700, 'ad_channel': 4, 'action': true}, // 辉煌快手 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'hk58': {'sid': '10416658', 'convert_id': 293705, 'ad_channel': 4, 'action': true}, // 辉煌快手 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'hk79': {'sid': '10435979', 'convert_id': 294863, 'ad_channel': 4, 'action': true},  // 辉煌快手2021-7-10 2021-8-3 目前未投放，添加转化归因
  'hk78': {'sid': '10435978', 'convert_id': 294864, 'ad_channel': 4, 'action': true},  // 辉煌快手2021-7-10 2021-8-3 目前未投放，添加转化归因
  'ht22': {'sid': '1704704265284622', 'convert_id': 1704706597361667, 'ad_channel': 3, 'action': true}, // 辉煌头条 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'ht07': {'sid': '1704704265881607', 'convert_id': 1704706916376587, 'ad_channel': 3, 'action': true}, // 辉煌头条 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'ht78': {'sid': '1704704266419278', 'convert_id': 1704706963065859, 'ad_channel': 3, 'action': true}, // 辉煌头条 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'ht02': {'sid': '1704704266917902', 'convert_id': 1704707003479044, 'ad_channel': 3, 'action': true}, // 辉煌头条 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'ht91': {'sid': '1704831012803591', 'convert_id': 1704899895834637, 'ad_channel': 3, 'action': true}, // 2021-7-10 2021-8-3 目前未投放，添加转化归因
  'ht76': {'sid': '1704831013383176', 'convert_id': 1704900028094468, 'ad_channel': 3, 'action': true}, // 2021-7-10 2021-8-3 目前未投放，添加转化归因
  'ht26': {'sid': '1704831013926926', 'convert_id': 1704900108572675, 'ad_channel': 3, 'action': true}, // 2021-7-10 2021-8-3 目前未投放，添加转化归因
  'ht56': {'sid': '1704831014504456', 'convert_id': 1704900177024014, 'ad_channel': 3, 'action': true}, // 2021-7-10 2021-8-3 目前未投放，添加转化归因
  'ht89': {'sid': '1704831015013389', 'convert_id': 1704900244083719, 'ad_channel': 3, 'action': true}, // 2021-7-10 2021-8-3 目前未投放，添加转化归因
  'kt24': {'sid': '21043024', 'set_id': '1200002669', 'ad_channel': 1, 'action': true}, // 凯丽隆 2021-7-12 2021-8-3 目前未投放，添加转化归因
  'kt23': {'sid': '21043023', 'set_id': '1200002917', 'ad_channel': 1, 'action': true}, // 凯丽隆 2021-7-12 2021-8-3 目前未投放，添加转化归因
  'kt79': {'sid': '21039779', 'set_id': '1111962577', 'ad_channel': 1, 'action': true}, // 凯丽隆 2021-7-12 2021-8-3 目前未投放，添加转化归因
  'kt01': {'sid': '21032301', 'set_id': '1200002919', 'ad_channel': 1, 'action': true}, // 凯丽隆 2021-7-12 2021-8-3 目前未投放，添加转化归因
  'kt00': {'sid': '21032300', 'set_id': '1200002923', 'ad_channel': 1, 'action': true}, // 凯丽隆 2021-7-12 2021-8-3 目前未投放，添加转化归因
  'kk33': {'sid': '10419933', 'convert_id': 294540, 'ad_channel': 4, 'action': true}, // 凯丽隆快手 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'kk34': {'sid': '10419934', 'convert_id': 294542, 'ad_channel': 4, 'action': true}, // 凯丽隆快手 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'kk35': {'sid': '10419935', 'convert_id': 294536, 'ad_channel': 4, 'action': true}, // 凯丽隆快手 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'kk36': {'sid': '10419936', 'convert_id': 294550, 'ad_channel': 4, 'action': true}, // 凯丽隆快手 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'kk37': {'sid': '10419937', 'convert_id': 294551, 'ad_channel': 4, 'action': true}, // 凯丽隆快手 2021-7-9 2021-8-3 目前未投放，添加转化归因
  'kk93': {'sid': '10439393', 'convert_id': 299168, 'ad_channel': 4, 'action': true}, // 凯丽隆快手 2021-7-19 2021-8-3 目前未投放，添加转化归因
  'kk94': {'sid': '10439394', 'convert_id': 299172, 'ad_channel': 4, 'action': true}, // 凯丽隆快手 2021-7-19 2021-8-3 目前未投放，添加转化归因
  'kk95': {'sid': '10439395', 'convert_id': 299175, 'ad_channel': 4, 'action': true}, // 凯丽隆快手 2021-7-19 2021-8-3 目前未投放，添加转化归因
  'kd85': {'sid': '1704507968975885', 'convert_id': 1704795330874372, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-9 2021-8-3 添加转化归因
  'kd15': {'sid': '1704681124215815', 'convert_id': 1704795605189643, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-9 2021-8-6 添加转化归因
  'kd40': {'sid': '1704684286599240', 'convert_id': 1704795667653707, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-9 2021-8-6 添加转化归因
  'kd75': {'sid': '1704684287059975', 'convert_id': 1704795733267464, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-9 2021-8-6 添加转化归因
  'kd28': {'sid': '1704684287467528', 'convert_id': 1704795791924235, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-9 2021-8-6 添加转化归因
  'kd72': {'sid': '1705950669272072', 'convert_id': 1705953601368072, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-22  2021-8-6 添加转化归因
  'kd08': {'sid': '1705950668825608', 'convert_id': 1705953780551683, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-22  2021-8-6 添加转化归因
  'kd34': {'sid': '1705950668190734', 'convert_id': 1705953918760964, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-22  2021-8-6 添加转化归因
  'kd36': {'sid': '1705950667568136', 'convert_id': 1705954133708877, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-22  2021-8-6 添加转化归因
  'kd67': {'sid': '1705950648945672', 'convert_id': 1705954219693067, 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-7-22  2021-8-6 添加转化归因
  'kd03': {'sid': '1710848827012103', 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-9-15 添加新账户
  'kd23': {'sid': '1710848826556423', 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-9-15 添加新账户
  'kd51': {'sid': '1710848826118151', 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-9-15 添加新账户
  'kd60': {'sid': '1710848804913160', 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-9-15 添加新账户
  'kd88': {'sid': '1710848825634888', 'ad_channel': 3, 'action': true}, // 凯丽隆头条，抖音 2021-9-15 添加新账户
  'md49': {'sid': '1704683974030349', 'convert_id': 1704789771917339, 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-7-9 2021-8-2 目前未投放，改为转化归因
  'md54': {'sid': '1704521231487054', 'convert_id': 1704790391900167, 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-7-9 2021-8-2 目前未投放，改为转化归因
  'md05': {'sid': '1704683973000205', 'convert_id': 1704792818140238, 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-7-9 2021-8-2 目前未投放，改为转化归因
  'md09': {'sid': '1704683972432909', 'convert_id': 1704792912929796, 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-7-9 2021-8-2 目前未投放，改为转化归因
  'md44': {'sid': '1705057694401544', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-8-26 目前未投放，改为转化归因
  'md69': {'sid': '1705057694893069', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-8-26 目前未投放，改为转化归因
  'md23': {'sid': '1709222946958423', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-9-9 目前未投放，改为转化归因
  'md96': {'sid': '1709222946367496', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-9-9 目前未投放，改为转化归因
  'md35': {'sid': '1709222949475335', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-9-22 新增账户
  'md84': {'sid': '1711128320565384', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-9-22 新增账户
  'md42': {'sid': '1711131121353742', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-9-22 新增账户
  'md70': {'sid': '1711131121785870', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-10-14 新增账户
  'md71': {'sid': '1711131122304071', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-10-14 新增账户
  'md87': {'sid': '1711131122825287', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-10-14 新增账户
  'md04': {'sid': '1711131124688904', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-10-14 新增账户
  'md85': {'sid': '1711131125174285', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-10-14 新增账户
  'md77': {'sid': '1711131245246477', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-10-14 新增账户
  'md28': {'sid': '1711131245675528', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-10-14 新增账户
  'md72': {'sid': '1711131246142472', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-10-14 新增账户
  'md214': {'sid': '1711131247067214', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-11-5 新增账户 大学生需求
  'md454': {'sid': '1711131247549454', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-11-5 新增账户 大学生需求
  'md935': {'sid': '1711131247996935', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-11-5 新增账户 大学生需求
  'md847': {'sid': '1711131248419847', 'ad_channel': 3, 'action': true}, // 盟耀头条 2021-11-5 新增账户 大学生需求
  'mt98': {'sid': '21027898', 'set_id': '1112035546', 'ad_channel': 1, 'action': true}, // 盟耀腾讯 2021-7-9 2021-8-2更改为转化归因
  'mt99': {'sid': '21027899', 'set_id': '1111958843', 'ad_channel': 1, 'action': true}, // 盟耀腾讯 2021-7-9 2021-8-2更改为转化归因
  'mt97': {'sid': '21027897', 'set_id': '1200001508', 'ad_channel': 1, 'action': true}, // 转化API测试
  'mt00': {'sid': '21027900', 'set_id': '1200001513', 'ad_channel': 1, 'action': true}, // 盟耀腾讯 2021-7-9 2021-8-2更改为转化归因
  'mt01': {'sid': '21027901', 'ad_channel': 1, 'action': true}, // 盟耀腾讯 2021-10-14
  'mt03': {'sid': '21027903', 'ad_channel': 1, 'action': true}, // 盟耀腾讯 2021-10-14
  'mt05': {'sid': '21027905', 'ad_channel': 1, 'action': true}, // 盟耀腾讯 2021-10-14
  'mk74': {'sid': '10415074', 'convert_id': 294498, 'ad_channel': 4, 'action': true}, // 盟耀快手 2021-7-9 2021-8-4更改为转化归因
  'mk47': {'sid': '10421047', 'convert_id': 294500, 'ad_channel': 4, 'action': true}, // 盟耀快手 2021-7-9 2021-8-4更改为转化归因
  'mk49': {'sid': '10421049', 'convert_id': 298830, 'ad_channel': 4, 'action': true}, // 盟耀快手 2021-7-17 2021-8-4更改为转化归因
  'mk50': {'sid': '10421050', 'convert_id': 302602, 'ad_channel': 4, 'action': true}, // 盟耀快手 2021-7-26 2021-8-3更改为转化归因
  'mk53': {'sid': '10421053', 'ad_channel': 4, 'action': true}, // 盟耀快手 2021-9-22 新增账户
  'mk54': {'sid': '10421054', 'ad_channel': 4, 'action': true}, // 盟耀快手 2021-9-22 新增账户
  'mk59': {'sid': '10421059', 'ad_channel': 4, 'action': true}, // 盟耀快手 2021-10-14 新增账户
  'mk65': {'sid': '10421065', 'ad_channel': 4, 'action': true}, // 盟耀快手 2021-10-14 新增账户
  'zt59': {'sid': '21049159', 'set_id': '1200004110', 'ad_channel': 1, 'action': true}, // 武汉卓尔腾讯 2021-7-13 7-30做为转化归因测试
  'zt60': {'sid': '21049160', 'set_id': '1200004114', 'ad_channel': 1, 'action': true}, // 武汉卓尔腾讯 2021-7-13 2021-7-13 7-30做为转化归因测试
  'zt61': {'sid': '21049161', 'set_id': '1111965433', 'ad_channel': 1, 'action': true}, // 武汉卓尔腾讯 2021-7-13 2021-7-13 7-30做为转化归因测试
  'zt64': {'sid': '21033264', 'set_id': '1112042246', 'ad_channel': 1, 'action': true}, // 武汉卓尔腾讯 2021-7-13 7-30做为转化归因测试
  'gd01': {'sid': '11001863', 'uc_id': '11001863'}, // uc渠道  2021-7-17
  'gd02': {'sid': '11001865', 'uc_id': '11001865'}, // uc渠道  2021-7-17
  'gd03': {'sid': '11001867', 'uc_id': '11001867'}, // uc渠道  2021-7-17
  'gd04': {'sid': '11001868', 'uc_id': '11001868'}, // uc渠道  2021-7-17
  'gd05': {'sid': '11001869', 'uc_id': '11001869'}, // uc渠道  2021-7-17
  'xt09': {'sid': '22075209', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xt63': {'sid': '22076263', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xt64': {'sid': '22076264', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xt65': {'sid': '22076265', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xt66': {'sid': '22076266', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xt68': {'sid': '22076268', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xt71': {'sid': '22076271', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xt72': {'sid': '22076272', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xt75': {'sid': '22076275', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xt78': {'sid': '22076278', 'ad_channel': 1, 'action': true}, // 侠客行广点通  2021-10-15
  'xk65': {'sid': '10990665', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
  'xk78': {'sid': '10990678', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
  'xk85': {'sid': '10990685', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
  'xk87': {'sid': '10990687', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
  'xk89': {'sid': '10990689', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
  'xk95': {'sid': '10990695', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
  'xk99': {'sid': '10990699', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
  'xk05': {'sid': '10990705', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
  'xk11': {'sid': '10990711', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
  'xk14': {'sid': '10990714', 'ad_channel': 4, 'action': true}, // 侠客行快手  2021-10-15
};
const accountList = [
  {'name': 'tt', 'ad_channel': 3}, // 亿码 广点通，抖音，快手
  {'name': 'dy', 'ad_channel': 3},
  {'name': 'ks', 'ad_channel': 4},
  {'name': 'tx', 'ad_channel': 1},
  {'name': 'dt', 'ad_channel': 1}, // 东润 广点通，抖音，快手
  {'name': 'dk', 'ad_channel': 4},
  {'name': 'dr', 'ad_channel': 3},
  {'name': 'hm', 'ad_channel': 1}, // 辉煌  广点通，抖音，快手
  {'name': 'hk', 'ad_channel': 4},
  {'name': 'ht', 'ad_channel': 3},
  {'name': 'kt', 'ad_channel': 1}, // 凯里隆  广点通，抖音，快手
  {'name': 'kk', 'ad_channel': 4},
  {'name': 'kd', 'ad_channel': 3},
  {'name': 'md', 'ad_channel': 3}, // 盟耀 广点通，抖音，快手
  {'name': 'mt', 'ad_channel': 1},
  {'name': 'mk', 'ad_channel': 4},
  {'name': 'zt', 'ad_channel': 1}, // 卓尔 广点通
  {'name': 'gd'}, // UC
  {'name': 'xt', 'ad_channel': 1}, // 侠客行 广点通，抖音(未开启)，快手
  {'name': 'xk', 'ad_channel': 4},
  {'name': 'xd', 'ad_channel': 3}, 
  {'name': 'yt', 'ad_channel': 1}, // 优矩&云网 广点通，抖音(未开启)，快手
  {'name': 'yk', 'ad_channel': 4},
  {'name': 'yd', 'ad_channel': 3},
  {'name': 'et', 'ad_channel': 1}, // 其它
  {'name': 'ek', 'ad_channel': 4},
  {'name': 'ed', 'ad_channel': 3}
]
const accountName = accountList.map(item => item.name)
export {platFormData, dataType, accountList, accountName}